export * from '@primeuix/themes/lara/speeddial';
export { default } from '@primeuix/themes/lara/speeddial';
